module.exports = __webpack_public_path__ + "img/remove_full_watermark2.e3e52494.jpg";